// import firebase from "firebase";
import { OlabUtils } from "./olabutils.js";

// Helper function
// function degToRad(degrees) {
//     return degrees * Math.PI / 180;
// };

class OlabItem {
  constructor(item) {
    if (item == null) {
      this.initItem();
    } else {
      let hp = Object.prototype.hasOwnProperty;
      this.editDisplayState = hp.call(item, "editDisplayState")
        ? item.editDisplayState
        : "inline";
      this.name = hp.call(item, "name") ? item.name : null;
      this.name_uc = hp.call(item, "name_uc") ? item.name_uc : null;
      this.olab_id = hp.call(item, "olab_id") ? item.olab_id : null;
      this.olab_type = hp.call(item, "olab_type") ? item.olab_type : null;
      this.olab_type = hp.call(item, "olab_type") ? item.olab_type : null;
      this.library_id = hp.call(item, "library_id") ? item.library_id : null;
      this.microbe_type = hp.call(item, "microbe_type")
        ? item.microbe_type
        : null;
      this.desc = hp.call(item, "desc") ? item.desc : null;
      this.desc_hyperlink = hp.call(item, "desc_hyperlink")
        ? item.desc_hyperlink
        : null;
      this.download_file = hp.call(item, "download_file")
        ? item.download_file
        : null;
      this.source = hp.call(item, "source") ? item.source : null;
      this.creator = hp.call(item, "creator") ? item.creator : null;
      this.creator_uc = hp.call(item, "creator_uc") ? item.creator_uc : null;
      this.seq_origin = hp.call(item, "seq_origin") ? item.seq_origin : null;
      this.seq = hp.call(item, "seq")
        ? item.seq != null
          ? item.seq.toUpperCase()
          : null
        : null;

      // Additional fields for library sequence
      let gStats = hp.call(item, "gene_stats") ? item.gene_stats : null;
      this.gene_stats = {
        len: 0,
        num_a: 0,
        num_t: 0,
        num_c: 0,
        num_g: 0,
        short_seq: null
      };
      if (gStats) {
        this.gene_stats.len = hp.call(gStats, "len") ? gStats.len : 0;
        this.gene_stats.num_a = hp.call(gStats, "num_a") ? gStats.num_a : 0;
        this.gene_stats.num_t = hp.call(gStats, "num_t") ? gStats.num_t : 0;
        this.gene_stats.num_c = hp.call(gStats, "num_c") ? gStats.num_c : 0;
        this.gene_stats.num_g = hp.call(gStats, "num_g") ? gStats.num_g : 0;
        this.gene_stats.short_seq = hp.call(gStats, "short_seq")
          ? gStats.short_seq
          : null;
      }
      // Additional fields for strain
      this.parent_id = hp.call(item, "parent_id") ? item.parent_id : null;
      this.project_id = hp.call(item, "project_id") ? item.project_id : null;
      this.storage = hp.call(item, "storage") ? item.storage : null;
      this.mutations = hp.call(item, "mutations") ? item.mutations : null;
      this.antibiotic_resistance = hp.call(item, "antibiotic_resistance")
        ? item.antibiotic_resistance
        : null;
      this.plasmid_id = hp.call(item, "plasmid_id") ? item.plasmid_id : null;
      this.show_genes = hp.call(item, "show_genes") ? item.show_genes : false;
      this.wgs_confirmed = hp.call(item, "wgs_confirmed")
        ? item.wgs_confirmed
        : false;

      // Additional field for project
      this.start_date = hp.call(item, "start_date") ? item.start_date : null;
      this.end_date = hp.call(item, "end_date") ? item.end_date : null;

      // Additional field for package
      this.package_seq_type = hp.call(item, "package_seq_type")
        ? item.package_seq_type
        : "library_sequence";
      this.package_type = hp.call(item, "package_type")
        ? item.package_type
        : null;

      // Additional field for cart and package
      this.comps = hp.call(item, "comps") ? item.comps : [];
      this.cstbs = hp.call(item, "cstbs") ? item.cstbs : [];

      // Additional fields for cart only
      this.design_id = hp.call(item, "design_id") ? item.design_id : null;
      this.design_name = hp.call(item, "design_name") ? item.design_name : null;
    }

    // This feedback can change depending of input state
    this.invalidSeqFeedback = "Sequence is a required field";
  }

  static getOlabItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          olab_id: item.olab_id,
          olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          library_id: item.library_id,
          microbe_type: item.microbe_type,
          desc: item.desc,
          desc_hyperlink: item.desc_hyperlink,
          download_file: item.download_file,
          source: item.source,
          creator: item.creator,
          creator_uc: item.creator_uc,
          seq_origin: item.seq_origin,
          seq: item.seq,
          gene_stats: item.gene_stats,
          parent_id: item.parent_id,
          project_id: item.project_id,
          storage: item.storage,
          mutations: item.mutations,
          antibiotic_resistance: item.antibiotic_resistance,
          plasmid_id: item.plasmid_id,
          show_genes: item.show_genes,
          wgs_confirmed: item.wgs_confirmed,
          start_date: item.start_date,
          end_date: item.end_date,
          package_seq_type: item.package_seq_type,
          package_type: item.package_type,
          comps: item.comps,
          cstbs: item.cstbs,
          design_id: item.design_id,
          design_name: item.design_name
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }

  static getInvalidFeedbacks() {
    let fbMessage = {
      name: "Name is a required field",
      startDate: "Start date is a required field",
      libraryID: "Library ID is a required field",
      seq_origin: "Sequence Origin is a required field",
      parentID: "Parent ID is a required field",
      antibioticResistance: "Antibiotic Resistance is a required field",
      storage: "Storage is a required field"
    };
    return fbMessage;
  }

  initItem() {
    OlabUtils.infoLog("OlabItem.initItem() ...");
    // true if duplicate sequence is found else false
    this.seqExisted = false;
    this.old_seq = null;

    // Common fields: internal use
    this.editDisplayState = "inline";
    this.olab_id = null;
    this.olab_type = null;
    this.name_uc = null;
    this.creator_uc = null;

    // Common fields: User settable
    this.name = null;
    this.creator = null;
    this.desc = null;
    this.desc_hyperlink = null;
    this.download_file = null;

    // Additional fields for library_sequence
    this.library_id = null;
    this.seq_origin = null;
    this.seq = null;
    this.gene_stats = null;

    // Additional fields for strain
    this.microbe_type = null;
    this.parent_id = null;
    this.project_id = null;
    this.plasmid_id = null;
    this.show_genes = false;
    this.source = null;
    this.storage = null;
    this.mutations = null;
    this.antibiotic_resistance = null;
    this.wgs_confirmed = false;

    // Additional field for project
    this.start_date = null;
    this.end_date = null;

    // Additional field for package
    this.package_seq_type = "library_sequence";
    this.package_type = null;

    // Additional field for cart and package
    this.comps = [];
    this.cstbs = [];

    // Additional fields for cart only
    this.design_id = null;
    this.design_name = null;
  }

  set(item) {
    this.seqExisted = item.seqExisted;
    this.old_seq = item.old_seq;

    this.editDisplayState = item.editDisplayState;
    this.olab_id = item.olab_id;
    this.olab_type = item.olab_type;
    this.name = item.name;
    this.name_uc = item.name_uc;
    this.library_id = item.library_id;
    this.microbe_type = item.microbe_type;
    this.desc = item.desc;
    this.desc_hyperlink = item.desc_hyperlink;
    this.download_file = item.download_file;
    this.source = item.source;
    this.creator = item.creator;
    this.creator_uc = item.creator_uc;
    this.seq_origin = item.seq_origin;
    this.seq = item.seq;
    // Note: Shallow set (only set reference)
    this.gene_stats = item.gene_stats;
    this.parent_id = item.parent_id;
    this.project_id = item.project_id;
    this.storage = item.storage;
    this.mutations = item.mutations;
    this.antibiotic_resistance = item.antibiotic_resistance;
    this.plasmid_id = item.plasmid_id;
    this.show_genes = item.show_genes;
    this.wgs_confirmed = item.wgs_confirmed;
    this.start_date = item.start_date;
    this.end_date = item.end_date;
    this.package_seq_type = item.package_seq_type;
    this.package_type = item.package_type;
    this.comps = item.comps;
    this.cstbs = item.cstbs;
    this.design_id = item.design_id;
    this.design_name = item.design_name;
  }

  setUniqueKey() {
    // Set additional fields and append unique key for search to work later
    if (this.name != null) {
      this.name_uc = this.name.toUpperCase() + " ^%#- " + this.olab_id;
    }
    if (this.creator != null) {
      this.creator_uc = this.creator.toUpperCase() + " ^%#- " + this.olab_id;
    }
  }

  getSeqValidState() {
    return this.processSeq() ? "is-valid" : "is-invalid";
  }

  setSeqExisted(status) {
    if (status) {
      this.seqExisted = true;
      this.getSeqValidState();
    } else {
      this.seqExisted = false;
    }
  }

  processSeq() {
    let seqValid = true;
    let invalidFB = "";

    if (this.seqExisted && this.old_seq !== this.seq) {
      // Reset seqExisted since it is a new seq
      this.seqExisted = false;
    }

    // Preprocess seq
    if (this.seq) {
      this.seq = this.seq.toUpperCase();
      // console.log("==== " + this.seq);
      // only keep a-zA-Z and remove other characters from seq
      this.seq = this.seq.replace(/[^a-zA-Z]/g, "");
      // console.log(">>>> " + this.seq);
    }

    if (!this.library_id) {
      seqValid = false;
      invalidFB = "Need to select a valid library. Library ID can't be null";
    } else if (!this.seq) {
      seqValid = false;
      invalidFB = "Need to specify a sequence";
    } else if (this.seqExisted === true) {
      seqValid = false;
      invalidFB =
        "Sequence found in library. Duplicate sequence is disallowed.";
    } else {
      // console.log("this.library_id = " + this.library_id);
      if (this.library_id.substr(0, this.library_id.indexOf(" ")) == "LA") {
        // LA: Need to use this characters
        // http://130.88.97.239/bioactivity/aacodefrm.html
        seqValid = !this.seq.match(/[^acdefghiklmnpqrstvwy]/gi);
        invalidFB =
          "Sequence has to be [a,c,d,e,f,g,h,i,k,l,m,n,p,q,r,s,t,v,w,y]";
      } else {
        seqValid = !this.seq.match(/[^acgt]/gi);
        invalidFB = "Sequence has to be [a,c,g,t]";
      }
    }
    // console.log("seq = " + this.seq + ", valid = " + seqValid);
    this.old_seq = this.seq;
    this.invalidSeqFeedback = invalidFB;
    return seqValid;
  }

  processItemField(fieldName) {
    return fieldName == null || fieldName == "" ? "is-invalid" : "is-valid";
  }

  getValidState(fieldName) {
    // OlabUtils.infoLog("getValidState: fieldName = " + fieldName);
    return this.processItemField(fieldName);
  }

  isValid(fieldName) {
    return this.processItemField(fieldName) == "is-valid";
  }

  static infoLog(item) {
    OlabUtils.infoLog("item.olab_id = " + item.olab_id);
    OlabUtils.infoLog("item.olab_type = " + item.olab_type);
    OlabUtils.infoLog("item.name = " + item.name);
    OlabUtils.infoLog("item.name_uc = " + item.name_uc);
    OlabUtils.infoLog("item.microbe_type = " + item.microbe_type);
    OlabUtils.infoLog("item.source = " + item.source);
    OlabUtils.infoLog("item.creator = " + item.creator);
    OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
    OlabUtils.infoLog("item.seq_origin = " + item.seq_origin);
    OlabUtils.infoLog("item.seq = " + item.seq);
    OlabUtils.infoLog("item.gene_stats = " + item.gene_stats);

    OlabUtils.infoLog("item.gene_stats.len = " + item.gene_stats.len);
    OlabUtils.infoLog("item.gene_stats.num_a = " + item.gene_stats.num_a);
    OlabUtils.infoLog("item.gene_stats.num_t = " + item.gene_stats.num_t);
    OlabUtils.infoLog("item.gene_stats.num_c = " + item.gene_stats.num_c);
    OlabUtils.infoLog("item.gene_stats.num_g = " + item.gene_stats.num_g);
    OlabUtils.infoLog(
      "item.gene_stats.short_seq = " + item.gene_stats.short_seq
    );
    OlabUtils.infoLog("item.library_id = " + item.library_id);
    OlabUtils.infoLog("item.parent_id = " + item.parent_id);
    OlabUtils.infoLog("item.project_id = " + item.project_id);
    OlabUtils.infoLog("item.mutations = " + item.mutations);
    OlabUtils.infoLog(
      "item.antibiotic_resistance = " + item.antibiotic_resistance
    );
    OlabUtils.infoLog("item.plasmid_id = " + item.plasmid_id);
    OlabUtils.infoLog("item.show_genes = " + item.show_genes);
    OlabUtils.infoLog("item.storage = " + item.storage);
    OlabUtils.infoLog("item.wgs_confirmed = " + item.wgs_confirmed);
    OlabUtils.infoLog("item.desc = " + item.desc);
    OlabUtils.infoLog("item.desc_hyperlink = " + item.desc_hyperlink);
    OlabUtils.infoLog("item.download_file " + item.download_file);
    OlabUtils.infoLog("item.start_date = " + item.start_date);
    OlabUtils.infoLog("item.end_date = " + item.end_date);
    OlabUtils.infoLog("item.package_seq_type = " + item.package_seq_type);
    OlabUtils.infoLog("item.package_type = " + item.package_type);
    if (item.comps !== null) {
      OlabUtils.infoLog("item.comps = [");
      item.comps.forEach(element => {
        OlabUtils.infoLog(
          "   olab_id = " + element.olab_id + ", qty = " + element.qty
        );
      });
      OlabUtils.infoLog("]");
    }
    if (item.cstbs !== null) {
      OlabUtils.infoLog("item.comps = [");
      item.cstbs.forEach(element => {
        OlabUtils.infoLog(
          "   box_id = " +
            element.box_id +
            ", comp_olab_id = " +
            element.comp_olab_id
        );
      });
      OlabUtils.infoLog("]");
    }
    OlabUtils.infoLog("item.design_id = " + item.design_id);
    OlabUtils.infoLog("item.design_name = " + item.design_name);
  }
}

export { OlabItem };
